export default "__VITE_ASSET__Du$jFDZh__"